import builder from '../builder';
import PhoneBook from '../../streamline-icons/light/phone-book.svg';

export default builder('IconPhoneBookLight', PhoneBook);
